import React from 'react';
import styled from 'styled-components';
import { Paper } from '@material-ui/core';
import 'react-quill/dist/quill.snow.css';

import { initial } from './index';
import useOneCardDb from '../hooks/useOneCardDb';
import useMemoCardContentDb from '../hooks/useMemoCardContentDb';

type CardPaperProps = {
  width: number;
  height: number;
  $frameDisplay?: boolean;
  $frameColor?: string;
  $backgroundDisplay?:boolean;
  $backgroundColor?: string;
}
const CardPaper = styled(Paper)<CardPaperProps>`
  position: relative;
  width: ${props => props.width + 'px'};
  min-height: ${props => props.height + 'px'};
  border: ${props => props.$frameDisplay ? '1px solid ' + props.$frameColor : undefined};
  background-color: ${props => props.$backgroundDisplay ? props.$backgroundColor : '#11ffee00'};
  box-sizing: border-box;
  overflow: hidden auto;
`
type HtmlDivProps = {
  width: number;
}
const HtmlDiv = styled.div<HtmlDivProps>`
  position: absolute;
  width: ${props => props.width + 'px'};
  top: 0;
  left: 0;
`

type MemoCardProps = {
  cardId: string;
  widthValue?: number;
  heightValue?: number;
}
const MemoCard: React.FC<MemoCardProps> = ({cardId, widthValue, heightValue}) => {
  const card = useOneCardDb(cardId);
  const [, value] = useMemoCardContentDb(cardId);
  if (!card) return <></>;

  const width = widthValue ? widthValue : card.currentWidth ? card.currentWidth : initial.cardWidth;
  const height = heightValue ? heightValue : card.currentHeight ? card.currentHeight : initial.cardHeight;

  return (
    <CardPaper className="magica-card"
      width={width} height={height}
      $frameDisplay={card.frame.display} $frameColor={card.frame.color}
      $backgroundDisplay={card.background.display} $backgroundColor={card.background.color}
    >
      { value?.content &&
        <HtmlDiv width={width} className="ql-editor" dangerouslySetInnerHTML={{__html: value?.content}} />
      }
    </CardPaper>
  );
}

export default MemoCard;
